import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import Vacancies from "../pages/vacancies/page";
import Candidates from "../pages/candidates/page";
import Pipeline from "../pages/pipeline/page";
import Scoring from "../pages/scoring/page";
import Portrait from "../pages/portrait/page";
import Emails from "../pages/emails/page";
import CandidateDetail from "../pages/candidates/detail/page";
import Members from "../pages/members/page";
import Organizations from "../pages/organizations/page";
import HHRU from "../pages/hhru/page";
import PublicVacancyLanding from "../pages/public/vacancy/page";
import PublicJobsList from "../pages/public/jobs/page";
import PublicInterviewBooking from "../pages/public/interview/page";
import Interviews from "../pages/interviews/page";
import Sourcing from "../pages/sourcing/page";
import SourcingProject from "../pages/sourcing/detail/page";
import SourcingCandidate from "../pages/sourcing/candidate/page";
import SourcingNewRun from "../pages/sourcing/new-run/page";
import Layout from "../components/feature/Layout";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/public/vacancy/:slug",
    element: <PublicVacancyLanding />,
  },
  {
    path: "/public/jobs",
    element: <PublicJobsList />,
  },
  {
    path: "/i/:token",
    element: <PublicInterviewBooking />,
  },
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Navigate to="/vacancies" replace />,
      },
      {
        path: "/vacancies",
        element: <Vacancies />,
      },
      {
        path: "/candidates",
        element: <Candidates />,
      },
      {
        path: "/candidates/:id",
        element: <CandidateDetail />,
      },
      {
        path: "/pipeline",
        element: <Pipeline />,
      },
      {
        path: "/sourcing",
        element: <Sourcing />,
      },
      {
        path: "/sourcing/:id",
        element: <SourcingProject />,
      },
      {
        path: "/sourcing/:id/candidates/:cid",
        element: <SourcingCandidate />,
      },
      {
        path: "/sourcing/:id/new-run",
        element: <SourcingNewRun />,
      },
      {
        path: "/interviews",
        element: <Interviews />,
      },
      {
        path: "/scoring",
        element: <Scoring />,
      },
      {
        path: "/portrait",
        element: <Portrait />,
      },
      {
        path: "/emails",
        element: <Emails />,
      },
      {
        path: "/hhru",
        element: <HHRU />,
      },
      {
        path: "/members",
        element: <Members />,
      },
      {
        path: "/organizations",
        element: <Organizations />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;